'use client'

import { type ReactNode } from 'react'

interface DashboardTemplateProps {
	children: ReactNode
	/** Header slot (e.g., page title, breadcrumbs) */
	header?: ReactNode
	/** Sidebar slot */
	sidebar?: ReactNode
}

/**
 * Template for dashboard-style pages with optional sidebar and header.
 * Used by profile, settings, admin, and similar pages.
 */
export function DashboardTemplate({ children, header, sidebar }: DashboardTemplateProps) {
	return (
		<div className="flex min-h-svh w-full">
			{sidebar && (
				<aside className="border-brand-border bg-brand-surface hidden w-64 shrink-0 border-r lg:flex">
					{sidebar}
				</aside>
			)}
			<main className="flex flex-1 flex-col">
				{header && (
					<header className="border-brand-border bg-brand-surface/80 sticky top-0 z-30 border-b px-6 py-4 backdrop-blur-sm">
						{header}
					</header>
				)}
				<div className="flex-1 px-4 py-6 md:px-6 lg:px-8">{children}</div>
			</main>
		</div>
	)
}
